import React, { useState, useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import "./edit-profile.scss";
import CloseIconWithText from "../../assets/close_icon.png";
import {
  disableHelpButton,
  enableHelpButton,
} from "../common/DisableHelpButton/DisableHelpButton";
import { Formik, FieldArray } from "formik";
import * as yup from "yup";
import UploadTemplateForm from "./UploadTemplateForm";
import ClinicDetailsForm from "./ClinicDetailsForm";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import unAuthorizedError from "../Errors/unAuthorizedError";
import Loader from "../UI Component/Loader/Loader";
import { doctorProfileFiles } from "../../Util/API Calls/APIList";
import defaultImage from "../../assets/placeholder.png";
import swal from "sweetalert";
import PdfContainer from "../UI Component/DocumentViewer/PdfContainer";
import Checked from "../../assets/checked.png";
import uploadIcon from "../../assets/upload-temp.png";
import editIcon from "../../assets/profile-edit.svg";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const EditProfile = (props) => {
  const [activeId, setActiveId] = useState();
  const [activeFooterCardId, setActiveFooterCardId] = useState();
  let inputRef;
  const [uploadTemplate, setUploadTemplate] = useState({});
  const [uploadHeaderError, setUploadHeaderError] = useState(false);
  const [uploadFooterError, setUploadFooterError] = useState(false);
  const [uploadLogoError, setUploadLogoError] = useState(false);
  const [uploadFooterTemplate, setUploadFooterTemplate] = useState({});
  const [uploadLogo, setUploadLogo] = useState({});
  const [userInformation_Initial_Value, setUserInformation_Initial_Value] =
    useState({
      doctor_profile_details: {
        prefix_name: "",
        first_name: "",
        last_name: "",
      },
    });
  const [loader, setLoader] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Preview Prescription",
    fileType: ".pdf",
  });
  const [documentShow, setDocumentShow] = useState(false);
  const [preprintStaionaryDisplay, setPreprintStaionaryDisplay] =
    useState(false);
  const [prnitMarginUnit, setPrnitMarginUnit] = useState("cm");
  const [PmrActClsName, setPmrActClsName] = useState("mrdact-rlbt");
  const [RmrActClsName, setRmrActClsName] = useState("mrdact-rlbt");
  const [customMarginVal, setCustomMarginVal] = useState({
    rxTop: "",
    rxLeft: "",
    rxBottom: "",
    rxRight: "",
    rcptTop: "",
    rcptLeft: "",
    rcptBottom: "",
    rcptRight: "",
  });
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const ProfileInformationSchema = yup.object().shape({
    doctor_profile_details: yup.object().shape({
      is_doctor_name_enabled: yup.bool().default(true),
      is_doctor_degree_enabled: yup.bool().default(true),
      is_doctor_registration_number_enabled: yup.bool().default(true),
      is_doctor_address_enabled: yup.bool().default(true),
      is_doctor_registered_mob_no_enabled: yup.bool().default(true),
      is_doctor_registered_email_enabled: yup.bool().default(true),
      is_doctor_alternate_no_enabled: yup.bool().default(false),
      is_doctor_consultation_timings_enabled: yup.bool().default(true),
      is_dr_appointment_booking_link_enabled: yup.bool().default(false),
      is_dr_appointment_booking_qr_enabled: yup.bool().default(false),
      is_show_all: yup.bool().default(true),
      is_show_all_details: yup.bool().default(true),
      is_default_c2c_footer_to_be_shown_in_receipt: yup.bool().default(false),
      is_uploaded_header_template_to_be_used: yup.bool().default(false),
      header_template: yup
        .mixed()
        .nullable()
        .when("is_uploaded_header_template_to_be_used", {
          is: true,
          then: yup.object().required("Please upload header template"),
          otherwise: yup.object().nullable(true),
        }),
      is_uploaded_footer_template_to_be_used: yup.bool().default(false),
      footer_template: yup
        .mixed()
        .nullable()
        .when("is_uploaded_footer_template_to_be_used", {
          is: true,
          then: yup.object().required("Please upload footer template"),
          otherwise: yup.object().nullable(true),
        }),
      doctor_alternate_number: yup
        .string()
        .trim()
        .when("is_doctor_alternate_no_enabled", {
          is: true,
          then: yup
            .string()
            .trim()
            // .max(13, "Must be valid and exactly 10 digits")
            .matches(
              // /^(\+91[\-\s]?)?(\+72[\-\s]?)?(\+52[\-\s]?)?(\+81[\-\s]?)?(\+92[\-\s]?)?[6789]\d{9}$/,
              /^(?=.*[0-9])[- +()0-9]+$/,
              "Please provide a valid Phone Number"
            )
            .required("Please enter contact no"),
          otherwise: yup
            .string()
            .trim()
            // .max(13, "Must be valid and exactly 10 digits")
            .matches(
              // /^(\+91[\-\s]?)?(\+72[\-\s]?)?(\+52[\-\s]?)?(\+81[\-\s]?)?(\+92[\-\s]?)?[6789]\d{9}$/,
              /^(?=.*[0-9])[- +()0-9]+$/,
              "Please provide a valid Phone Number"
            ),
        }),
      description: yup
        .string()
        .trim()
        .max(1000, "Only 1000 characters are allowed")
        .required("Please enter professional statement"),
      doctor_consultation_timings: yup
        .string()
        .trim()
        .when("is_doctor_consultation_timings_enabled", {
          is: true,
          then: yup
            .string()
            .max(1000, "Only 1000 characters are allowed")
            .required("Please enter hospital timings"),
        }),
      doctor_address: yup
        .string()
        .trim()
        .max(1000, "Only 1000 characters are allowed")
        .required("Please enter address"),
      doctor_registered_email: yup.string().trim(),
    }),
    doctor_hospital_details: yup.array().of(
      yup.object().shape({
        is_hospital_name_enabled: yup.bool().default(false),
        is_hospital_address_enabled: yup.bool().default(false),
        is_hospital_contact_no_enabled: yup.bool().default(false),
        is_hospital_timings_enabled: yup.bool().default(false),
        is_hospital_logo_enabled: yup.bool().default(false),
        hospital_name: yup
          .string()
          .trim()
          .when("is_hospital_name_enabled", {
            is: true,
            then: yup
              .string()
              .max(1000, "Only 1000 characters are allowed")
              .required("Please enter clinic/hospital name"),
          }),
        hospital_logo: yup
          .string()
          .trim()
          .when("is_hospital_logo_enabled", {
            is: true,
            then: yup.string().required("Please upload logo"),
          }),
        hospital_address: yup
          .string()
          .trim()
          .when("is_hospital_address_enabled", {
            is: true,
            then: yup
              .string()
              .max(1000, "Only 1000 characters are allowed")
              .required("Please enter clinic/hospital address"),
          }),
        hospital_contact_number: yup
          .string()
          .trim()
          .when("is_hospital_contact_no_enabled", {
            is: true,
            then: yup
              .string()
              .trim()
              // .max(13, "Must be valid and exactly 10 digits")
              .matches(
                // /^(\+91[\-\s]?)?(\+72[\-\s]?)?(\+52[\-\s]?)?(\+81[\-\s]?)?(\+92[\-\s]?)?[6789]\d{9}$/,
                /^(?=.*[0-9])[- +()0-9]+$/,
                "Please provide a valid Phone Number"
              )
              .required("Please enter clinic/hospital contact no"),
            otherwise: yup
              .string()
              .trim()
              .max(13, "Must be valid and exactly 10 digits")
              .matches(
                // /^(\+91[\-\s]?)?(\+72[\-\s]?)?(\+52[\-\s]?)?(\+81[\-\s]?)?(\+92[\-\s]?)?[6789]\d{9}$/,
                /^(?=.*[0-9])[- +()0-9]+$/,
                "Please provide a valid Phone Number"
              ),
          }),
        hospital_timings: yup
          .string()
          .trim()
          .when("is_hospital_timings_enabled", {
            is: true,
            then: yup
              .string()
              .max(1000, "Only 1000 characters are allowed")
              .required("Please enter consultation timing"),
          }),
        // Rest of your amenities object properties
      })
    ),
  });

  useEffect(() => {
    getProfileData();
  }, []);

  const getProfileData = async () => {
    setLoader(true);
    afterLoginApiAxios
      .post(
        "/doctor/get-my-profile-rev1",
        {
          doctor_id:
            props?.doctorId && props?.doctorId !== null
              ? props?.doctorId
              : userId,
          staff_id: staffId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response && response?.data) {
          if (response?.data?.statusCode == 200) {
            if (response?.data?.doctor_hospital_details?.length === 0) {
              response.data.doctor_hospital_details.push({
                hospital_name: "",
                hospital_address: "",
                hospital_contact_number: "",
                hospital_timings: "",
                hospital_logo_path: "",
                is_hospital_name_enabled: "False",
                is_hospital_logo_enabled: "False",
                is_hospital_address_enabled: "False",
                is_hospital_contact_no_enabled: "False",
                is_hospital_timings_enabled: "False",
              });
            }
            let data = {};
            data = response?.data;
            setActiveId(
              data.doctor_profile_details
                .is_uploaded_header_template_to_be_used == "True"
                ? 2
                : 1
            );
            setActiveFooterCardId(
              data.doctor_profile_details
                .is_uploaded_footer_template_to_be_used === "True"
                ? 2
                : 1
            );
            data.doctor_profile_details.is_doctor_name_enabled =
              data?.doctor_profile_details?.is_doctor_name_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_degree_enabled =
              data?.doctor_profile_details?.is_doctor_degree_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_registration_number_enabled =
              data?.doctor_profile_details
                ?.is_doctor_registration_number_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_address_enabled =
              data?.doctor_profile_details?.is_doctor_address_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_registered_mob_no_enabled =
              data?.doctor_profile_details
                ?.is_doctor_registered_mob_no_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_registered_email_enabled =
              data?.doctor_profile_details
                ?.is_doctor_registered_email_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_alternate_no_enabled =
              data?.doctor_profile_details?.is_doctor_alternate_no_enabled ==
              "False"
                ? false
                : true;
            data.doctor_profile_details.is_doctor_consultation_timings_enabled =
              data?.doctor_profile_details
                ?.is_doctor_consultation_timings_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_dr_appointment_booking_link_enabled =
              data?.doctor_profile_details
                ?.is_dr_appointment_booking_link_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_dr_appointment_booking_qr_enabled =
              data?.doctor_profile_details
                ?.is_dr_appointment_booking_qr_enabled == "False"
                ? false
                : true;
            data.doctor_profile_details.is_default_c2c_footer_to_be_shown_in_receipt =
              data?.doctor_profile_details
                ?.is_default_c2c_footer_to_be_shown_in_receipt == "False"
                ? false
                : true;
            data.doctor_profile_details.is_uploaded_header_template_to_be_used =
              data?.doctor_profile_details
                ?.is_uploaded_header_template_to_be_used == "False"
                ? false
                : true;
            data.doctor_profile_details.is_uploaded_footer_template_to_be_used =
              data?.doctor_profile_details
                ?.is_uploaded_footer_template_to_be_used == "False"
                ? false
                : true;
            data.doctor_profile_details.is_show_all_details =
              data?.doctor_profile_details?.is_show_all_details === "False"
                ? false
                : true;
            data.doctor_profile_details.is_show_all =
              data?.doctor_profile_details?.is_show_all === "False"
                ? false
                : true;
            if (data && data?.doctor_hospital_details?.length > 0) {
              data.doctor_hospital_details.map((details) => {
                details.is_hospital_name_enabled =
                  details?.is_hospital_name_enabled == "False" ? false : true;
                details.is_hospital_logo_enabled =
                  details?.is_hospital_logo_enabled == "False" ? false : true;
                details.is_hospital_address_enabled =
                  details?.is_hospital_address_enabled == "False"
                    ? false
                    : true;
                details.is_hospital_contact_no_enabled =
                  details?.is_hospital_contact_no_enabled == "False"
                    ? false
                    : true;
                details.is_hospital_timings_enabled =
                  details?.is_hospital_timings_enabled == "False"
                    ? false
                    : true;
                return data;
              });
            }

            setUploadFooterTemplate(
              data?.doctor_profile_details?.footer_template
            );
            setProfileImage(data?.doctor_profile_details?.profile_picture_url);
            setUploadTemplate(data?.doctor_profile_details?.header_template);
            setUploadLogo(data?.doctor_hospital_details[0]?.hospital_logo);
            setUserInformation_Initial_Value(data);

            setCustomMarginVal({
              rxTop:
                data?.doctor_profile_details?.custom_margin_dimensions?.rxTop >
                0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rxTop
                  : "",
              rxLeft:
                data?.doctor_profile_details?.custom_margin_dimensions?.rxLeft >
                0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rxLeft
                  : "",
              rxBottom:
                data?.doctor_profile_details?.custom_margin_dimensions
                  ?.rxBottom > 0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rxBottom
                  : "",
              rxRight:
                data?.doctor_profile_details?.custom_margin_dimensions
                  ?.rxRight > 0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rxRight
                  : "",
              rcptTop:
                data?.doctor_profile_details?.custom_margin_dimensions
                  ?.rcptTop > 0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rcptTop
                  : "",
              rcptLeft:
                data?.doctor_profile_details?.custom_margin_dimensions
                  ?.rcptLeft > 0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rcptLeft
                  : "",
              rcptBottom:
                data?.doctor_profile_details?.custom_margin_dimensions
                  ?.rcptBottom > 0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rcptBottom
                  : "",
              rcptRight:
                data?.doctor_profile_details?.custom_margin_dimensions
                  ?.rcptRight > 0
                  ? data?.doctor_profile_details?.custom_margin_dimensions
                      ?.rcptRight
                  : "",
            });
            setPrnitMarginUnit(
              data?.doctor_profile_details?.custom_margin_dimensions?.unit
            );

            if (
              data?.doctor_profile_details?.custom_margins_enabled == "True"
            ) {
              setPreprintStaionaryDisplay(true);
            }

            setLoader(false);
            if (
              data?.doctor_hospital_details?.length &&
              data?.doctor_hospital_details[0]?.hospital_id
            ) {
              localStorage.setItem(
                "hospital_id",
                data?.doctor_hospital_details[0]?.hospital_id
              );
            }
          } else {
            setLoader(false);
            swal({
              title: "Something went wrong. Please contact to admin",
              text: "",
              icon: "warning",
              button: "Okay",
            });
          }
        }
      })
      .catch(function (error) {
        C2CConsole.log(error);
        setLoader(false);

        if (error?.response?.status === 403) {
          unAuthorizedError(() => {
            this.props.history.push("/doctor/login");
          });
        }
      });
  };

  function selectHeaderCard(evt, id) {
    setActiveId(id);
  }
  function selectFooterCard(evt, id) {
    setActiveFooterCardId(id);
  }
  const addClick = (push, setFieldValue) => {
    push({
      hospital_name: "",
      hospital_address: "",
      hospital_contact_number: "",
      hospital_logo: {},
      hospital_logo_path: {},
      is_hospital_name_enabled: false,
      is_hospital_address_enabled: false,
      is_hospital_contact_no_enabled: false,
      is_hospital_timings_enabled: false,
    });
    setFieldValue("doctor_profile_details.is_show_all", false);
  };

  const removeClick = (i, remove) => {
    remove(i);
  };
  const editOnChangeHandler = (event, element) => {
    if (element === "image") {
      const file = event.target.files[0];
      if (!file.type.includes("image")) {
        //TODO: Show Error
        C2CConsole.error("Image is not Selected");
        return;
      }
      // Encodes Image to upload and Preview
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        setProfileImage({
          value: reader.result,
          name: file.name,
        });
      };
    } else {
      alert("The allowed extension is .jpeg/.jpg/.png/.gif only.");
    }
  };

  const setSelectAll = (e, hospitalDetails) => {
    hospitalDetails.map((details, index) => {
      if (e.target.checked) {
        details["is_hospital_name_enabled"] = true;
        details["is_hospital_address_enabled"] = true;
        details["is_hospital_contact_no_enabled"] = true;
        details["is_hospital_timings_enabled"] = true;
        details["is_hospital_logo_enabled"] = true;
      } else {
        details["is_hospital_name_enabled"] = false;
        details["is_hospital_address_enabled"] = false;
        details["is_hospital_contact_no_enabled"] = false;
        details["is_hospital_timings_enabled"] = false;
        details["is_hospital_logo_enabled"] = false;
      }
    });
  };

  const setSelectAllDetails = (e, setFieldValue) => {
    if (e.target.checked) {
      setFieldValue(
        "doctor_profile_details.is_doctor_registered_mob_no_enabled",
        true
      );
      setFieldValue(
        "doctor_profile_details.is_doctor_alternate_no_enabled",
        true
      );
      setFieldValue(
        "doctor_profile_details.is_doctor_registered_email_enabled",
        true
      );
      setFieldValue(
        "doctor_profile_details.is_doctor_consultation_timings_enabled",
        true
      );
      setFieldValue(
        "doctor_profile_details.is_dr_appointment_booking_qr_enabled",
        true
      );
      setFieldValue(
        "doctor_profile_details.is_dr_appointment_booking_link_enabled",
        true
      );
    } else {
      setFieldValue(
        "doctor_profile_details.is_doctor_registered_mob_no_enabled",
        false
      );
      setFieldValue(
        "doctor_profile_details.is_doctor_alternate_no_enabled",
        false
      );
      setFieldValue(
        "doctor_profile_details.is_doctor_registered_email_enabled",
        false
      );
      setFieldValue(
        "doctor_profile_details.is_doctor_consultation_timings_enabled",
        false
      );
      setFieldValue(
        "doctor_profile_details.is_dr_appointment_booking_qr_enabled",
        false
      );
      setFieldValue(
        "doctor_profile_details.is_dr_appointment_booking_link_enabled",
        false
      );
    }
  };

  function arrayBufferToBase64(buffer) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  const previewTemplate = (values) => {
    setLoader(true);
    let data = {};
    delete values["statusCode"];
    delete values["doctor_id"];
    data = values;
    data.doctor_hospital_details[0]["hospital_logo"] = uploadLogo;
    data.doctor_hospital_details["header_template"] =
      uploadTemplate === null ? {} : uploadTemplate;
    data.doctor_hospital_details["footer_template"] =
      uploadFooterTemplate === null ? {} : uploadFooterTemplate;
    let prescription_data = {};
    data.doctor_profile_details["header_template"] = data
      .doctor_profile_details["header_template"]
      ? data.doctor_profile_details["header_template"]
      : {};
    data.doctor_profile_details["footer_template"] = data
      .doctor_profile_details["footer_template"]
      ? data.doctor_profile_details["footer_template"]
      : {};
    data.doctor_profile_details["is_uploaded_header_template_to_be_used"] =
      Object?.keys(uploadTemplate)?.length !== 0 && activeId === 2;
    data.doctor_profile_details["is_uploaded_footer_template_to_be_used"] =
      Object?.keys(uploadFooterTemplate)?.length !== 0 &&
      activeFooterCardId === 2;
    prescription_data["prescription_data"] = data;

    prescription_data["custom_margins_enabled"] = preprintStaionaryDisplay;

    prescription_data["custom_margin_dimensions"] = {
      unit: prnitMarginUnit,
      rxLeft: customMarginVal.rxLeft,
      rxRight: customMarginVal.rxRight,
      rxTop: customMarginVal.rxTop,
      rxBottom: customMarginVal.rxBottom,
      rcptLeft: customMarginVal.rcptLeft,
      rcptRight: customMarginVal.rcptRight,
      rcptTop: customMarginVal.rcptTop,
      rcptBottom: customMarginVal.rcptBottom,
    };

    afterLoginApiAxios
      .post("/user/pdfgenerator", prescription_data, {
        headers: { authorization: localStorage.getItem("id_token") },
      })
      .then((response) => {
        if (response?.data?.data) {
          const base64String = arrayBufferToBase64(response?.data?.data);
          fileDetails.fileURL = base64String;
          setFileDetails(fileDetails);
          setLoader(false);
          setDocumentShow(true);
        } else {
          setLoader(false);
          swal({
            title: "Sorry",
            text: "Prescription could not be downloaded",
            icon: "warning",
          });
        }
      })
      .catch(function (error) {
        setLoader(false);
        swal({
          title: "Sorry",
          text: "Prescription could not be downloaded",
          icon: "warning",
        });
      });
  };
  const renderDocument = (width) => {
    if (documentShow) {
      return (
        <PdfContainer
          cancelHandler={() => closeNotification()}
          url={`data:application/pdf;base64,${fileDetails?.fileURL}`}
          fileName={fileDetails?.fileName}
          fileType={fileDetails?.fileType}
          width={width || ""}
        />
      );
    }
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileName: "Preview Prescription",
      fileURL: "",
      fileType: "",
    });
  };

  const updateProfile = (values) => {
    setLoader(true);
    let data = {};
    let custom_margin = {};
    data = values;
    data.doctor_profile_details["profile_picture"] = profileImage;
    data.doctor_profile_details["registration_number"] =
      values?.doctor_profile_details?.medical_reg_no;
    data["doctor_hospital_details"] = values?.doctor_hospital_details;
    data.doctor_profile_details["header_template"] = uploadTemplate;
    data.doctor_profile_details["footer_template"] = uploadFooterTemplate;
    data.doctor_profile_details["is_uploaded_header_template_to_be_used"] =
      Object?.keys(uploadTemplate)?.length !== 0 && activeId === 2;
    data.doctor_profile_details["is_uploaded_footer_template_to_be_used"] =
      Object?.keys(uploadFooterTemplate)?.length !== 0 &&
      activeFooterCardId === 2;
    data.doctor_hospital_details[0]["is_logo_deleted"] =
      uploadLogo &&
      Object?.keys(uploadLogo)?.length === 0 &&
      uploadLogo?.constructor === Object
        ? "True"
        : "False";
    data.doctor_hospital_details[0]["hospital_logo"] = uploadLogo;
    data.doctor_hospital_details[0]["hospital_logo_path"] = uploadLogo
      ? uploadLogo
      : "";
    data.doctor_profile_details["doctor_alternate_number"] = [
      {
        phone_no: data.doctor_profile_details["doctor_alternate_number"],
        is_primary: false,
        show_in_prescription:
          data.doctor_profile_details["is_doctor_alternate_no_enabled"],
      },
    ];
    data.doctor_profile_details["is_header_template_deleted"] =
      uploadTemplate?.presigned_url ? "False" : "True";
    data.doctor_profile_details["is_footer_template_deleted"] =
      uploadFooterTemplate?.presigned_url ? "False" : "True";

    custom_margin = {
      custom_margin_enabled: preprintStaionaryDisplay ? "True" : "False",
      custom_margin_dimensions: {
        unit: prnitMarginUnit,
        rxLeft: customMarginVal.rxLeft,
        rxRight: customMarginVal.rxRight,
        rxTop: customMarginVal.rxTop,
        rxBottom: customMarginVal.rxBottom,
        rcptLeft: customMarginVal.rcptLeft,
        rcptRight: customMarginVal.rcptRight,
        rcptTop: customMarginVal.rcptTop,
        rcptBottom: customMarginVal.rcptBottom,
      },
    };

    afterLoginApiAxios
      .post(
        "/doctor/update-my-profile-rev2",
        {
          ...data,
          doctor_id:
            props?.doctorId && props?.doctorId !== null
              ? props?.doctorId
              : userId,
          staff_id: staffId,
          custom_margin: custom_margin,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        setLoader(false);
        if (response.data) {
          if (response?.data?.statusCode === 200) {
            props.closeView("updateSuccess");
          } else {
            getProfileData();
            swal({
              title: "Sorry",
              text: "Something Went Wrong. Please contact to admin",
              icon: "warning",
            });
          }
        } else {
          getProfileData();
          swal({
            title: "Sorry",
            text: "Something Went Wrong. Please contact to admin",
            icon: "warning",
          });
        }
      })
      .catch((err) => {
        setLoader(false);
        C2CConsole.log(err);
      });
  };

  const handleStaionaryDisplay = () => {
    setPreprintStaionaryDisplay(!preprintStaionaryDisplay);
  };

  useEffect(() => {
    CustmrCheck();
  }, [customMarginVal]);

  const CustmrCheck = () => {
    if (
      customMarginVal.rxRight &&
      customMarginVal.rxLeft &&
      customMarginVal.rxTop &&
      customMarginVal.rxBottom
    ) {
      setPmrActClsName("mract-rlbt");
    } else if (
      customMarginVal.rxRight &&
      customMarginVal.rxLeft &&
      customMarginVal.rxBottom
    ) {
      setPmrActClsName("mract-rlb");
    } else if (
      customMarginVal.rxRight &&
      customMarginVal.rxTop &&
      customMarginVal.rxBottom
    ) {
      setPmrActClsName("mract-rbt");
    } else if (
      customMarginVal.rxRight &&
      customMarginVal.rxTop &&
      customMarginVal.rxLeft
    ) {
      setPmrActClsName("mract-rlt");
    } else if (
      customMarginVal.rxBottom &&
      customMarginVal.rxTop &&
      customMarginVal.rxLeft
    ) {
      setPmrActClsName("mract-lbt");
    } else if (customMarginVal.rxRight && customMarginVal.rxLeft) {
      setPmrActClsName("mract-rl");
    } else if (customMarginVal.rxRight && customMarginVal.rxBottom) {
      setPmrActClsName("mract-rb");
    } else if (customMarginVal.rxRight && customMarginVal.rxTop) {
      setPmrActClsName("mract-rt");
    } else if (customMarginVal.rxLeft && customMarginVal.rxBottom) {
      setPmrActClsName("mract-lb");
    } else if (customMarginVal.rxLeft && customMarginVal.rxTop) {
      setPmrActClsName("mract-lt");
    } else if (customMarginVal.rxBottom && customMarginVal.rxTop) {
      setPmrActClsName("mract-bt");
    } else if (customMarginVal.rxRight) {
      setPmrActClsName("mract-r");
    } else if (customMarginVal.rxLeft) {
      setPmrActClsName("mract-l");
    } else if (customMarginVal.rxTop) {
      setPmrActClsName("mract-t");
    } else if (customMarginVal.rxBottom) {
      setPmrActClsName("mract-b");
    } else {
      setPmrActClsName("mrdact-rlbt");
    }

    if (
      customMarginVal.rcptRight &&
      customMarginVal.rcptLeft &&
      customMarginVal.rcptTop &&
      customMarginVal.rcptBottom
    ) {
      setRmrActClsName("mract-rlbt");
    } else if (
      customMarginVal.rcptRight &&
      customMarginVal.rcptLeft &&
      customMarginVal.rcptBottom
    ) {
      setRmrActClsName("mract-rlb");
    } else if (
      customMarginVal.rcptRight &&
      customMarginVal.rcptTop &&
      customMarginVal.rcptBottom
    ) {
      setRmrActClsName("mract-rbt");
    } else if (
      customMarginVal.rcptRight &&
      customMarginVal.rcptTop &&
      customMarginVal.rcptLeft
    ) {
      setRmrActClsName("mract-rlt");
    } else if (
      customMarginVal.rcptBottom &&
      customMarginVal.rcptTop &&
      customMarginVal.rcptLeft
    ) {
      setRmrActClsName("mract-lbt");
    } else if (customMarginVal.rcptRight && customMarginVal.rcptLeft) {
      setRmrActClsName("mract-rl");
    } else if (customMarginVal.rcptRight && customMarginVal.rcptBottom) {
      setRmrActClsName("mract-rb");
    } else if (customMarginVal.rcptRight && customMarginVal.rcptTop) {
      setRmrActClsName("mract-rt");
    } else if (customMarginVal.rcptLeft && customMarginVal.rcptBottom) {
      setRmrActClsName("mract-lb");
    } else if (customMarginVal.rcptLeft && customMarginVal.rcptTop) {
      setRmrActClsName("mract-lt");
    } else if (customMarginVal.rcptBottom && customMarginVal.rcptTop) {
      setRmrActClsName("mract-bt");
    } else if (customMarginVal.rcptRight) {
      setRmrActClsName("mract-r");
    } else if (customMarginVal.rcptLeft) {
      setRmrActClsName("mract-l");
    } else if (customMarginVal.rcptTop) {
      setRmrActClsName("mract-t");
    } else if (customMarginVal.rcptBottom) {
      setRmrActClsName("mract-b");
    } else {
      setRmrActClsName("mrdact-rlbt");
    }
  };

  const handleMarginChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (prnitMarginUnit == "cm" && value <= 10) {
      if (name == "rxLeft" || name == "rxRight") {
        if (value <= 5) {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: value,
          });
        } else {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: "",
          });
        }
      } else if (name == "rcptLeft" || name == "rcptRight") {
        if (value <= 4) {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: value,
          });
        } else {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: "",
          });
        }
      } else {
        setCustomMarginVal({
          ...customMarginVal,
          [name]: value,
        });
      }
    } else if (prnitMarginUnit == "in" && value <= 3.93701) {
      if (e.target.name == "rxLeft" || e.target.name == "rxRight") {
        if (value <= 1.9685) {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: value,
          });
        } else {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: "",
          });
        }
      } else if (name == "rcptLeft" || name == "rcptRight") {
        if (value <= 1.57) {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: value,
          });
        } else {
          setCustomMarginVal({
            ...customMarginVal,
            [name]: "",
          });
        }
      } else {
        setCustomMarginVal({
          ...customMarginVal,
          [name]: value,
        });
      }
    } else {
      setCustomMarginVal({
        ...customMarginVal,
        [name]: "",
      });
    }
  };

  return (
    <>
      {loader || uploadFooterError || uploadHeaderError || uploadLogoError ? (
        <Loader />
      ) : (
        ""
      )}
      <Drawer
        anchor={"right"}
        open={props.openView}
        onClose={props.closeView}
        className="edit_profile_drawer"
      >
        {props.openView ? disableHelpButton() : enableHelpButton()}
        <Formik
          onSubmit={(values) => {
            let data = {};
            data = values;

            data.doctor_profile_details.is_doctor_name_enabled =
              data?.doctor_profile_details?.is_doctor_name_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_default_c2c_footer_to_be_shown_in_receipt =
              data?.doctor_profile_details
                ?.is_default_c2c_footer_to_be_shown_in_receipt == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_degree_enabled =
              data?.doctor_profile_details?.is_doctor_degree_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_registration_number_enabled =
              data?.doctor_profile_details
                ?.is_doctor_registration_number_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_address_enabled =
              data?.doctor_profile_details?.is_doctor_address_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_registered_mob_no_enabled =
              data?.doctor_profile_details
                ?.is_doctor_registered_mob_no_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_registered_email_enabled =
              data?.doctor_profile_details
                ?.is_doctor_registered_email_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_alternate_no_enabled =
              data?.doctor_profile_details?.is_doctor_alternate_no_enabled ==
              false
                ? "False"
                : "True";
            data.doctor_profile_details.is_doctor_consultation_timings_enabled =
              data?.doctor_profile_details
                ?.is_doctor_consultation_timings_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_dr_appointment_booking_link_enabled =
              data?.doctor_profile_details
                ?.is_dr_appointment_booking_link_enabled == false
                ? "False"
                : "True";
            data.doctor_profile_details.is_dr_appointment_booking_qr_enabled =
              data?.doctor_profile_details
                ?.is_dr_appointment_booking_qr_enabled == false
                ? "False"
                : "True";
            if (data && data?.doctor_hospital_details?.length > 0) {
              data.doctor_hospital_details.map((details) => {
                details.is_hospital_name_enabled =
                  details?.is_hospital_name_enabled == false ? "False" : "True";
                details.is_hospital_logo_enabled =
                  details?.is_hospital_logo_enabled == false ? "False" : "True";
                details.is_hospital_address_enabled =
                  details?.is_hospital_address_enabled == false
                    ? "False"
                    : "True";
                details.is_hospital_contact_no_enabled =
                  details?.is_hospital_contact_no_enabled == false
                    ? "False"
                    : "True";
                details.is_hospital_timings_enabled =
                  details?.is_hospital_timings_enabled == false
                    ? "False"
                    : "True";
                return;
              });
            }
            delete data["statusCode"];
            delete data["doctor_id"];
            updateProfile(values);
          }}
          initialValues={userInformation_Initial_Value}
          validationSchema={ProfileInformationSchema}
          enableReinitialize={true}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            handleBlur,
            onFocus,
            errors,
            touched,
            isSubmitting,
            setValues,
            setFieldError,
            setFieldValue,
          }) => (
            // <form>
            <>
              <div
                className="edit_profile_drawer_main_cont"
                style={{ padding: "10px", overflowX: "hidden" }}
                id="edit_profile"
              >
                <div>
                  <div className="edit_profile_drawer_heading">
                    <div className="d-flex justify-content-between heading align-items-center">
                      <div className="d-flex align-items-center">
                        <h4
                          className="mb-0 align-self-center header-title"
                          style={{ fontSize: "25px", fontWeight: "bold" }}
                        >
                          Update Profile
                        </h4>
                      </div>
                      <img
                        className="closeIcon-text"
                        src={CloseIconWithText}
                        alt=""
                        onClick={props.closeView}
                      />
                    </div>
                  </div>

                  <div className="row" style={{ marginTop: "20px" }}>
                    <div className="col-sm-12 col-md-5">
                      <div className="row align-items-center">
                        <div className="col-4">
                          <div onClick={() => inputRef.click()}>
                            <img
                              src={
                                profileImage?.value
                                  ? profileImage?.value
                                  : profileImage
                                  ? doctorProfileFiles + profileImage
                                  : defaultImage
                              }
                              class="rounded-circle profile_image"
                              alt="profileImage"
                            />
                            <span className="camera_icon">
                              <i
                                className="fa fa-camera"
                                style={{ fontSize: "11px" }}
                              />
                            </span>
                            <input
                              type="file"
                              hidden={true}
                              accept="image/*"
                              ref={(ref) => (inputRef = ref)}
                              onChange={(event) =>
                                editOnChangeHandler(event, "image")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <h6
                            className="font-weight-bold"
                            style={{ fontSize: "20px" }}
                          >
                            {values?.doctor_profile_details?.prefix_name
                              ? `${values?.doctor_profile_details?.prefix_name}. ${values?.doctor_profile_details?.first_name} ${values?.doctor_profile_details?.last_name}`
                              : `${values?.doctor_profile_details?.first_name} ${values?.doctor_profile_details?.last_name}`}
                          </h6>
                          <h6
                            style={{ fontSize: "14px" }}
                            className="text-capitalize"
                          >
                            {values?.doctor_profile_details?.display_name
                              ? values?.doctor_profile_details?.display_name
                              : null}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-7">
                      <div className="container p-3 ">
                        <textarea
                          name="doctor_profile_details.description"
                          className="form-control professional-text-area" //professional_statement
                          placeholder="Professional Statement"
                          value={values?.doctor_profile_details?.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          // maxLength="1000"
                        ></textarea>
                        {errors?.doctor_profile_details?.description &&
                          touched?.doctor_profile_details?.description && (
                            <div className="error">
                              {errors?.doctor_profile_details?.description}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      // marginTop: "20px",
                      height: "40px",
                      backgroundColor: "#E5E5E5",
                      position: "sticky",
                      top: "-11px",
                      zIndex: `${!documentShow ? "9999" : "1"}`,
                    }}
                    className="row align-items-center"
                  >
                    <div className="col-8 profile_header profile_header_left">
                      Details
                    </div>
                    <div className="col-4 profile_header profile_header_right">
                      Show in Prescription
                    </div>
                  </div>

                  {/* Pre-Printed Staionary Div checkBox */}
                  <div className="row mt-3">
                    <div className="col-12 pre_printed_stationary_div">
                      <div
                        className="d-flex align-items-center hover-pointer"
                        //  data-toggle="collapse"
                        //  href="#collapseThree"
                        onClick={handleStaionaryDisplay}
                      >
                        <label
                          className="pre-Staionary-checkBox hover-pointer"
                          style={
                            preprintStaionaryDisplay
                              ? { backgroundColor: "#17bae0" }
                              : null
                          }
                        >
                          <span>
                            {preprintStaionaryDisplay ? (
                              <i className="fa fa-check facheck"></i>
                            ) : null}
                          </span>
                        </label>
                        <span className="fnt-14">
                          Do You Have Pre-Printed Stationery?
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Pre-Printed Staionary Div checkBox */}

                  <div className="row mt-3">
                    <div className="col-12">
                      <div
                        className={`profile_summary ${
                          preprintStaionaryDisplay ? "is-Divdisabled" : ""
                        }`}
                      >
                        <div id="accordion" className="accordion">
                          <div className="card-container">
                            <div className="d-flex justify-content-between">
                              <div
                                className="card-header"
                                data-toggle="collapse"
                                href="#collapseOne"
                              >
                                <span className="circle_plus_minus"></span>
                                <a className="card-title">
                                  Default C2C Header (Personal Details)
                                </a>
                              </div>
                              <a
                                className="card-title m-0"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <div className="form_checkbox">
                                  {activeId !== 2 ? (
                                    <div class="container custom-control intermediate-checkbox custom-checkbox pr-2">
                                      <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customCheck"
                                        name="doctor_profile_details.is_show_all_details"
                                        checked={
                                          values?.doctor_profile_details
                                            ?.is_show_all_details
                                        }
                                        ref={(input) => {
                                          if (
                                            input &&
                                            !values?.doctor_profile_details
                                              ?.is_show_all_details
                                          ) {
                                            input.indeterminate = true;
                                          } else {
                                            if (input) {
                                              input.indeterminate = false;
                                            }
                                          }
                                        }}
                                        onChange={(e) => {
                                          setFieldValue(
                                            "doctor_profile_details.is_show_all_details",
                                            !values?.doctor_profile_details
                                              ?.is_show_all_details
                                          );
                                          setSelectAllDetails(e, setFieldValue);
                                        }}
                                      />
                                      <label
                                        class="custom-control-label"
                                        for="customCheck"
                                      ></label>
                                    </div>
                                  ) : (
                                    <label class="container custom-checkbox mb-0">
                                      <input
                                        type="checkbox"
                                        name="doctor_profile_details.is_uploaded_header_template_to_be_used"
                                        checked={
                                          values?.doctor_profile_details
                                            ?.is_uploaded_header_template_to_be_used
                                        }
                                        onChange={(e) => {
                                          setFieldValue(
                                            "doctor_profile_details.is_uploaded_header_template_to_be_used",
                                            !values?.doctor_profile_details
                                              ?.is_uploaded_header_template_to_be_used
                                          );
                                        }}
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                  )}
                                </div>
                              </a>
                            </div>
                            <div
                              id="collapseOne"
                              className={`card-body collapse ${
                                preprintStaionaryDisplay ? "hide" : "show"
                              } `}
                              data-parent="#accordion"
                            >
                              <div className="row mt-3">
                                {/* do not delete it */}
                                <div className="col-lg-6 col-6 d-flex flex-lg-row flex-column patient-list ">
                                  <div
                                    className={`card card_style cursor-pointer ${
                                      activeId == 1 ? "active-card" : ""
                                    }`}
                                    onClick={(evt) => selectHeaderCard(evt, 1)}
                                  >
                                    <div className="card-body d-flex flex-lg-column flex-row justify-content-center align-items-center">
                                      <img
                                        src={Checked}
                                        height="20"
                                        width="20"
                                        className="selected-card"
                                        id="checkedImage"
                                        style={{
                                          display: `${
                                            activeId == 1 ? "block" : "none"
                                          }`,
                                        }}
                                        alt="checkImage"
                                      />
                                      <div className="icon-container">
                                        <img
                                          src={editIcon}
                                          style={{ width: "25px" }}
                                          alt="edit"
                                        />
                                        <span className="accordian-body_heading">
                                          Enter Personal Details
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-6 d-flex flex-lg-row flex-column patient-list">
                                  <div
                                    className={`card card_style cursor-pointer ${
                                      activeId == 2 ? "active-card" : ""
                                    }`}
                                    onClick={(evt) => selectHeaderCard(evt, 2)}
                                  >
                                    <div className="card-body d-flex flex-lg-column flex-row justify-content-center align-items-center">
                                      <img
                                        src={Checked}
                                        height="20"
                                        width="20"
                                        className="selected-card"
                                        style={{
                                          display: `${
                                            activeId == 2 ? "block" : "none"
                                          }`,
                                        }}
                                        alt="checkImage"
                                      />
                                      <div className="icon-container">
                                        <img
                                          src={uploadIcon}
                                          style={{
                                            width: "25px",
                                          }}
                                          alt="upload"
                                        />
                                        <span className="accordian-body_heading">
                                          Upload Header Template
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {activeId === 1 ? (
                                <>
                                  <div
                                    className="row col-12 pt-2"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ENTER PERSONAL DETAILS
                                  </div>

                                  <div className="mt-3">
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3">
                                        <span className="form_label">
                                          Your Name
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          {values?.doctor_profile_details &&
                                            `${values?.doctor_profile_details?.prefix_name}. ${values?.doctor_profile_details?.first_name} ${values?.doctor_profile_details?.last_name}`}
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="name"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_doctor_name_enabled
                                            }
                                            disabled
                                          />
                                          <span class="checkmark disabled_field"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Degree
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          {`${
                                            values?.doctor_profile_details
                                              ?.degree
                                              ? values?.doctor_profile_details
                                                  ?.degree
                                              : "-"
                                          }`}
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="degree"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_doctor_degree_enabled
                                            }
                                            disabled
                                          />
                                          <span class="checkmark disabled_field"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Registration No.
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          {`${
                                            values?.doctor_profile_details
                                              ?.medical_reg_no
                                              ? values?.doctor_profile_details
                                                  ?.medical_reg_no
                                              : "-"
                                          }`}
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="registrationNo"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_doctor_registration_number_enabled
                                            }
                                            disabled
                                          />
                                          <span class="checkmark disabled_field"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Your Address
                                        </span>

                                        <span className="form_value form_input_width">
                                          <textarea
                                            name="doctor_profile_details.doctor_address"
                                            className="form-control form-text-area text_area_background" //form_text_area
                                            value={
                                              values?.doctor_profile_details
                                                ?.doctor_address
                                                ? values?.doctor_profile_details
                                                    ?.doctor_address
                                                : ""
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          ></textarea>
                                          {errors?.doctor_profile_details
                                            ?.doctor_address &&
                                            touched?.doctor_profile_details
                                              ?.doctor_address && (
                                              <div className="error">
                                                {
                                                  errors?.doctor_profile_details
                                                    ?.doctor_address
                                                }
                                              </div>
                                            )}
                                        </span>
                                        <div className="form_checkbox mobile_checkbox">
                                          <label class="container custom-checkbox mb-0">
                                            <input
                                              type="checkbox"
                                              name="is_doctor_address_enabled"
                                              checked={
                                                values?.doctor_profile_details
                                                  ?.is_doctor_address_enabled
                                              }
                                              disabled
                                            />
                                            <span class="checkmark disabled_field"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Registered Mobile No.
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          {`${
                                            values?.doctor_profile_details
                                              ?.doctor_registered_mobile_number
                                              ? values?.doctor_profile_details
                                                  ?.doctor_registered_mobile_number
                                              : ""
                                          }`}
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="doctor_profile_details.is_doctor_registered_mob_no_enabled"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_doctor_registered_mob_no_enabled
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                "doctor_profile_details.is_doctor_registered_mob_no_enabled",
                                                !values?.doctor_profile_details
                                                  ?.is_doctor_registered_mob_no_enabled
                                              )
                                            }
                                          />
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Alternate No.
                                        </span>
                                        <span className="form_value form_input_width">
                                          <input
                                            type="text"
                                            name="doctor_profile_details.doctor_alternate_number"
                                            value={
                                              values?.doctor_profile_details
                                                ?.doctor_alternate_number
                                                ?.length &&
                                              values?.doctor_profile_details
                                                ?.doctor_alternate_number[0]
                                                ?.phone_no
                                                ? values?.doctor_profile_details
                                                    ?.doctor_alternate_number[0]
                                                    .phone_no
                                                : values?.doctor_profile_details
                                                    ?.doctor_alternate_number
                                                ? values?.doctor_profile_details
                                                    ?.doctor_alternate_number
                                                : ""
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            // maxLength="10"
                                            className="form_input text_area_background"
                                          />
                                          {errors?.doctor_profile_details
                                            ?.doctor_alternate_number &&
                                            touched?.doctor_profile_details
                                              ?.doctor_alternate_number && (
                                              <div className="error">
                                                {
                                                  errors?.doctor_profile_details
                                                    ?.doctor_alternate_number
                                                }
                                              </div>
                                            )}
                                        </span>
                                        <div className="form_checkbox mobile_checkbox">
                                          <label class="container custom-checkbox mb-0">
                                            <input
                                              type="checkbox"
                                              name="doctor_profile_details.is_doctor_alternate_no_enabled"
                                              checked={
                                                values?.doctor_profile_details
                                                  ?.is_doctor_alternate_no_enabled
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  "doctor_profile_details.is_doctor_alternate_no_enabled",
                                                  !values
                                                    ?.doctor_profile_details
                                                    ?.is_doctor_alternate_no_enabled
                                                )
                                              }
                                            />
                                            <span class="checkmark"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Registered Email ID.
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          {`${
                                            values?.doctor_profile_details
                                              ?.doctor_registered_email
                                              ? values?.doctor_profile_details
                                                  ?.doctor_registered_email
                                              : ""
                                          }`}
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="doctor_profile_details.is_doctor_registered_email_enabled"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_doctor_registered_email_enabled
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                "doctor_profile_details.is_doctor_registered_email_enabled",
                                                !values?.doctor_profile_details
                                                  ?.is_doctor_registered_email_enabled
                                              )
                                            }
                                          />
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Consultation Timings
                                        </span>
                                        <span className="form_value form_input_width">
                                          <textarea
                                            name="doctor_profile_details.doctor_consultation_timings"
                                            className="form-control form-text-area text_area_background" //form_text_area
                                            value={
                                              values?.doctor_profile_details
                                                ?.doctor_consultation_timings
                                                ? values?.doctor_profile_details
                                                    ?.doctor_consultation_timings
                                                : ""
                                            }
                                            placeholder="Consultation timings"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            // maxLength="1000"
                                          ></textarea>
                                          {errors?.doctor_profile_details
                                            ?.doctor_consultation_timings &&
                                            touched?.doctor_profile_details
                                              ?.doctor_consultation_timings && (
                                              <div className="error">
                                                {
                                                  errors?.doctor_profile_details
                                                    ?.doctor_consultation_timings
                                                }
                                              </div>
                                            )}
                                        </span>
                                        <div className="form_checkbox mobile_checkbox">
                                          <label class="container custom-checkbox mb-0">
                                            <input
                                              type="checkbox"
                                              name="doctor_profile_details.is_doctor_consultation_timings_enabled"
                                              checked={
                                                values?.doctor_profile_details
                                                  ?.is_doctor_consultation_timings_enabled
                                              }
                                              onChange={() =>
                                                setFieldValue(
                                                  "doctor_profile_details.is_doctor_consultation_timings_enabled",
                                                  !values
                                                    ?.doctor_profile_details
                                                    ?.is_doctor_consultation_timings_enabled
                                                )
                                              }
                                            />
                                            <span class="checkmark"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="personal_details_row border-bottom">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Appointment Booking Link
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          {values?.doctor_profile_details
                                            ?.doctor_appointment_booking_link
                                            ? values?.doctor_profile_details
                                                ?.doctor_appointment_booking_link
                                            : ""}
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="doctor_profile_details.is_dr_appointment_booking_link_enabled"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_dr_appointment_booking_link_enabled
                                            }
                                            // maxLength="1000"
                                            onChange={() =>
                                              setFieldValue(
                                                "doctor_profile_details.is_dr_appointment_booking_link_enabled",
                                                !values?.doctor_profile_details
                                                  ?.is_dr_appointment_booking_link_enabled
                                              )
                                            }
                                          />
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="personal_details_row">
                                      <div className="form_row pb-3 pt-3">
                                        <span className="form_label">
                                          Appointment Booking QR
                                        </span>
                                        <span className="form_value font-weight-bold">
                                          -
                                        </span>
                                      </div>
                                      <div className="form_checkbox">
                                        <label class="container custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            name="doctor_profile_details.is_dr_appointment_booking_qr_enabled"
                                            checked={
                                              values?.doctor_profile_details
                                                ?.is_dr_appointment_booking_qr_enabled
                                            }
                                            onChange={() =>
                                              setFieldValue(
                                                "doctor_profile_details.is_dr_appointment_booking_qr_enabled",
                                                !values?.doctor_profile_details
                                                  ?.is_dr_appointment_booking_qr_enabled
                                              )
                                            }
                                          />
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <UploadTemplateForm
                                  title="Header Template"
                                  fileValidationLabel="Size limit : 5MB"
                                  setUploadTemplate={setUploadTemplate}
                                  setUploadHeaderError={setUploadHeaderError}
                                  uploadTemplate={uploadTemplate}
                                  setFieldValue={setFieldValue}
                                  values={values}
                                  error={
                                    errors?.doctor_profile_details
                                      ?.header_template &&
                                    touched?.doctor_profile_details
                                      ?.header_template
                                      ? errors?.doctor_profile_details
                                          ?.header_template
                                      : ""
                                  }
                                  use_case="upload-document-rev1"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`profile_summary ${
                          preprintStaionaryDisplay ? "is-Divdisabled" : ""
                        }`}
                      >
                        <div id="accordion" className="accordion">
                          <div className="card-container">
                            <div className="d-flex justify-content-between">
                              <div
                                className={`card-header 
                                ${
                                  errors &&
                                  errors?.doctor_hospital_details &&
                                  touched &&
                                  touched?.doctor_hospital_details
                                    ? ""
                                    : "collapsed"
                                }`}
                                data-toggle="collapse"
                                href="#collapseTwo"
                              >
                                <span className="circle_plus_minus"></span>
                                <a>
                                  Default C2C Footer (Clinic/Hospital Details)
                                </a>
                              </div>
                              <a className="card-title accordian_title m-0">
                                <div className="form_checkbox">
                                  <label class="container custom-checkbox mb-0">
                                    <input
                                      type="checkbox"
                                      name="doctor_profile_details.is_show_all"
                                      checked={
                                        activeFooterCardId == 2
                                          ? values?.doctor_profile_details
                                              ?.is_uploaded_footer_template_to_be_used
                                          : values?.doctor_profile_details
                                              ?.is_show_all
                                      }
                                      onChange={(e) => {
                                        if (activeFooterCardId == 2) {
                                          setFieldValue(
                                            "doctor_profile_details.is_uploaded_footer_template_to_be_used",
                                            !values?.doctor_profile_details
                                              ?.is_uploaded_footer_template_to_be_used
                                          );
                                        } else {
                                          setFieldValue(
                                            "doctor_profile_details.is_show_all",
                                            !values?.doctor_profile_details
                                              ?.is_show_all
                                          );
                                          setSelectAll(
                                            e,
                                            values?.doctor_hospital_details
                                          );
                                        }
                                      }}
                                    />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </a>
                            </div>
                            <div
                              id="collapseTwo"
                              className={`card-body collapse 
                              ${preprintStaionaryDisplay && "hide"}
                              ${
                                errors &&
                                errors?.doctor_hospital_details &&
                                touched &&
                                touched?.doctor_hospital_details
                                  ? "show"
                                  : ""
                              }
                    `}
                              data-parent="#accordion"
                            >
                              <div className="row mt-3">
                                {/* do not delete it  */}
                                <div className="col-lg-6 col-6 d-flex flex-lg-row flex-column patient-list ">
                                  <div
                                    className={`card card_style cursor-pointer ${
                                      activeFooterCardId == 1
                                        ? "active-card"
                                        : ""
                                    }`}
                                    onClick={(evt) => selectFooterCard(evt, 1)}
                                  >
                                    <div className="card-body d-flex flex-lg-column flex-row justify-content-center align-items-center">
                                      <img
                                        src={Checked}
                                        height="20"
                                        width="20"
                                        className="selected-card"
                                        id="checkedImage"
                                        style={{
                                          display: `${
                                            activeFooterCardId == 1
                                              ? "block"
                                              : "none"
                                          }`,
                                        }}
                                        alt="checkImage"
                                      />
                                      <div className="icon-container">
                                        <img
                                          src={editIcon}
                                          style={{ width: "25px" }}
                                          alt="edit"
                                        />
                                        <span className="accordian-body_heading">
                                          Enter Clinic Details
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-6 d-flex flex-lg-row flex-column patient-list">
                                  <div
                                    className={`card card_style cursor-pointer ${
                                      activeFooterCardId == 2
                                        ? "active-card"
                                        : ""
                                    }`}
                                    onClick={(evt) => selectFooterCard(evt, 2)}
                                  >
                                    <div className="card-body d-flex flex-lg-column flex-row justify-content-center align-items-center">
                                      <img
                                        src={Checked}
                                        height="20"
                                        width="20"
                                        className="selected-card"
                                        style={{
                                          display: `${
                                            activeFooterCardId == 2
                                              ? "block"
                                              : "none"
                                          }`,
                                        }}
                                        alt="checkImage"
                                      />
                                      <div className="icon-container">
                                        <img
                                          src={uploadIcon}
                                          style={{
                                            width: "25px",
                                          }}
                                          alt="upload"
                                        />
                                        <span className="accordian-body_heading">
                                          Upload Footer Template
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {activeFooterCardId === 1 ? (
                                <>
                                  <div className="footer_heading">
                                    Enter Clinic/Hospital Details
                                  </div>
                                  <FieldArray name={"doctor_hospital_details"}>
                                    {(FieldArrayProps) => {
                                      const { push, remove, form } =
                                        FieldArrayProps;
                                      const { values, errors, touched } = form;
                                      const { doctor_hospital_details } =
                                        values;
                                      return (
                                        <div>
                                          {doctor_hospital_details?.length >
                                          0 ? (
                                            <ClinicDetailsForm
                                              addClick={addClick}
                                              push={push}
                                              doctor_hospital_details={
                                                doctor_hospital_details
                                              }
                                              remove={remove}
                                              errors={errors}
                                              touched={touched}
                                              setFieldError={setFieldError}
                                              setFieldValue={setFieldValue}
                                              removeClick={removeClick}
                                              onHandleChange={handleChange}
                                              onHandleBlur={handleBlur}
                                              setUploadLogo={setUploadLogo}
                                              uploadLogo={uploadLogo}
                                              profile_details={values}
                                              setUploadLogoError={
                                                setUploadLogoError
                                              }
                                            />
                                          ) : null}
                                        </div>
                                      );
                                    }}
                                  </FieldArray>
                                  <div className="row m-0 mt-3">
                                    <div className="no-gutters d-flex">
                                      <label class="container-checkbox">
                                        <input
                                          type="checkbox"
                                          name={`doctor_profile_details.is_default_c2c_footer_to_be_shown_in_receipt`}
                                          checked={
                                            values?.doctor_profile_details
                                              ?.is_default_c2c_footer_to_be_shown_in_receipt
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              "doctor_profile_details.is_default_c2c_footer_to_be_shown_in_receipt",
                                              !values?.doctor_profile_details
                                                ?.is_default_c2c_footer_to_be_shown_in_receipt
                                            );
                                          }}
                                        />
                                        <span class="checkmark"></span>
                                      </label>
                                      <p
                                        className="font-weight-bold"
                                        style={{ fontSize: "14px" }}
                                      >
                                        Show Default C2C Footer (Clinic/Hospital
                                        Details) in receipt
                                      </p>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <UploadTemplateForm
                                  title="Footer Template"
                                  fileValidationLabel="Size limit : 5MB"
                                  setUploadFooterTemplate={
                                    setUploadFooterTemplate
                                  }
                                  setUploadFooterError={setUploadFooterError}
                                  uploadFooterTemplate={uploadFooterTemplate}
                                  setFieldValue={setFieldValue}
                                  values={values}
                                  error={
                                    errors?.doctor_profile_details
                                      ?.footer_template &&
                                    touched?.doctor_profile_details
                                      ?.footer_template
                                      ? errors?.doctor_profile_details
                                          ?.footer_template
                                      : ""
                                  }
                                  use_case="upload-document-rev1"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Pre-Printed Staionary */}
                      <div className="profile_summary">
                        <div id="staionary" className="accordion">
                          <div className="card-container">
                            <div className="d-flex justify-content-between align-items-center">
                              <div
                                className={`card-header ${
                                  !preprintStaionaryDisplay ? "collapsed" : ""
                                }`}
                                data-toggle="collapse"
                                href="#collapseThree"
                                style={{
                                  pointerEvents: !preprintStaionaryDisplay
                                    ? "none"
                                    : "",
                                }}
                              >
                                <span className="circle_plus_minus"></span>
                                <a>Pre-Printed Staionary</a>
                              </div>

                              <label
                                className="pre-Staionary-checkBox"
                                style={{
                                  backgroundColor: preprintStaionaryDisplay
                                    ? "#17bae0"
                                    : "",
                                }}
                              >
                                <span>
                                  {preprintStaionaryDisplay ? (
                                    <hr className="pre-Staionary-act-hr" />
                                  ) : null}
                                </span>
                              </label>
                            </div>
                            <div
                              id="collapseThree"
                              className={`card-body collapse ${
                                preprintStaionaryDisplay ? "show" : "hide"
                              }`}
                              data-parent="#staionary"
                            >
                              <div className="Pre-Printed-staionary-main">
                                <hr className="pre-Staionary-div-hr" />
                                <p className="fnt-14">Select your unit</p>
                                <div className="PPS-unit-div d-flex">
                                  <div
                                    className="PPS-cm-div fnt-14 d-flex mr-4 hover-pointer"
                                    onClick={() => {
                                      setPrnitMarginUnit("cm");
                                      setCustomMarginVal({
                                        rxTop: "",
                                        rxLeft: "",
                                        rxBottom: "",
                                        rxRight: "",
                                        rcptTop: "",
                                        rcptLeft: "",
                                        rcptBottom: "",
                                        rcptRight: "",
                                      });
                                    }}
                                  >
                                    <label
                                      className="pre-Staionary-checkBox hover-pointer"
                                      style={
                                        prnitMarginUnit == "cm"
                                          ? { backgroundColor: "#17bae0" }
                                          : null
                                      }
                                    >
                                      <span>
                                        {prnitMarginUnit == "cm" ? (
                                          <i className="fa fa-check facheck"></i>
                                        ) : null}
                                      </span>
                                    </label>
                                    Cm
                                  </div>

                                  <div
                                    className="PPS-inch-div fnt-14 d-flex hover-pointer"
                                    onClick={() => {
                                      setPrnitMarginUnit("in");
                                      setCustomMarginVal({
                                        rxTop: "",
                                        rxLeft: "",
                                        rxBottom: "",
                                        rxRight: "",
                                        rcptTop: "",
                                        rcptLeft: "",
                                        rcptBottom: "",
                                        rcptRight: "",
                                      });
                                    }}
                                  >
                                    <label
                                      className="pre-Staionary-checkBox hover-pointer"
                                      style={
                                        prnitMarginUnit == "in"
                                          ? { backgroundColor: "#17bae0" }
                                          : null
                                      }
                                    >
                                      <span>
                                        {prnitMarginUnit == "in" ? (
                                          <i className="fa fa-check facheck"></i>
                                        ) : null}
                                      </span>
                                    </label>
                                    Inch
                                  </div>
                                </div>

                                <div className="PPS-custom-mr-div">
                                  <div className="PPS-prescription-mr-div mt-5">
                                    <h6 className="fnt-14">
                                      Prescription Margin
                                    </h6>
                                    <div style={{ width: "25%" }}>
                                      <div className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded">
                                        <input
                                          type="number"
                                          name="rxTop"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rxTop >= 0
                                              ? customMarginVal.rxTop
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded"
                                        style={{ width: "25%" }}
                                      >
                                        <input
                                          type="number"
                                          name="rxLeft"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rxLeft >= 0
                                              ? customMarginVal.rxLeft
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                      <div
                                        className={`custom-mr-div m-3 ${PmrActClsName} `}
                                      >
                                        Prescription
                                      </div>
                                      <div
                                        className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded"
                                        style={{ width: "25%" }}
                                      >
                                        <input
                                          type="number"
                                          name="rxRight"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rxRight >= 0
                                              ? customMarginVal.rxRight
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                    </div>
                                    <div style={{ width: "25%" }}>
                                      <div className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded">
                                        <input
                                          type="number"
                                          name="rxBottom"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rxBottom >= 0
                                              ? customMarginVal.rxBottom
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="PPS-receipt-mr-div mt-5">
                                    <h6 className="fnt-14">Receipt Margin</h6>
                                    <div style={{ width: "25%" }}>
                                      <div className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded">
                                        <input
                                          type="number"
                                          name="rcptTop"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rcptTop >= 0
                                              ? customMarginVal.rcptTop
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded"
                                        style={{ width: "25%" }}
                                      >
                                        <input
                                          type="number"
                                          name="rcptLeft"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rcptLeft >= 0
                                              ? customMarginVal.rcptLeft
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                      <div
                                        className={`custom-mr-div m-3 ${RmrActClsName}`}
                                      >
                                        Receipt
                                      </div>
                                      <div
                                        className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded"
                                        style={{ width: "25%" }}
                                      >
                                        <input
                                          type="number"
                                          name="rcptRight"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rcptRight >= 0
                                              ? customMarginVal.rcptRight
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                    </div>
                                    <div style={{ width: "25%" }}>
                                      <div className="d-flex justify-content-center align-items-center cus-mr-inp-bg rounded">
                                        <input
                                          type="number"
                                          name="rcptBottom"
                                          className="cus-mr-width"
                                          value={
                                            customMarginVal.rcptBottom >= 0
                                              ? customMarginVal.rcptBottom
                                              : ""
                                          }
                                          onChange={handleMarginChange}
                                          placeholder="|"
                                        />
                                        <span className="fnt-14">
                                          {prnitMarginUnit}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Pre-Printed Staionary */}
                    </div>
                  </div>
                </div>
                <div
                  className={`d-flex flex-row justify-content-center shadow-container ${
                    !documentShow ? "fixed-bottom" : "container_Zindex"
                  }`}
                  style={{ position: "relative", marginTop: 160 }}
                >
                  <div className="btn-container">
                    <button
                      className="btn btn-sm secondary-button rounded-pill py-2 px-5 submit-btn btn-flex font-weight-bold"
                      onClick={() => previewTemplate(values)}
                      style={{
                        backgroundColor:
                          (uploadHeaderError ||
                            uploadLogoError ||
                            uploadFooterError) &&
                          "#fff",
                      }}
                      disabled={
                        uploadHeaderError ||
                        uploadLogoError ||
                        uploadFooterError
                      }
                    >
                      Preview
                    </button>
                    <button
                      type="submit"
                      className="btn btn-sm primary-cta-button rounded-pill py-2 px-5 btn-flex submit-btn"
                      onClick={handleSubmit}
                      // disabled={isSubmitting}
                      disabled={
                        uploadHeaderError ||
                        uploadLogoError ||
                        uploadFooterError
                      }
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
                {renderDocument("98%")}
              </div>
            </>
          )}
        </Formik>
      </Drawer>
    </>
  );
};

export default EditProfile;
